import Home from "@/pages/Home/Home";
import Ticket from "@/pages/Ticket/Ticket";
import TicketsOpened from "@/pages/Tickets/TicketsOpened";
import TicketsClosed from "@/pages/Tickets/TicketsClosed";
import Sales from "@/pages/Sales/Sales";
import Sale from "@/pages/Sale/Sale";
import Finances from "@/pages/Finances/Finances";
import Persons from "@/pages/Persons/Persons";
import GraduationReport from "@/pages/Graduation/GraduationReport";
import Orders from "@/pages/Orders/Orders";
import Order from "@/pages/Order/Order";
import Wells from "@/pages/Wells/Wells";
import Well from "@/pages/Well/Well";

export default [
  {
    path: "home",
    name: "home",
    component: Home,
    meta: {
      auth: true,
      title: "Home",
      icon: "home",
      toolbarColor: 0,
    },
  },
  {
    path: "tickets",
    name: "tickets",
    component: TicketsOpened,
    meta: {
      auth: true,
      title: "Chamados/Contatos Abertos",
      icon: "email",
      toolbarColor: "primary",
    },
  },
  {
    path: "tickets-closed",
    name: "tickets-closed",
    component: TicketsClosed,
    meta: {
      auth: true,
      title: "Chamados/Contatos Encerrados",
      icon: "email",
      toolbarColor: "primary",
    },
  },
  {
    path: "ticket/:id",
    name: "ticket",
    component: Ticket,
    meta: {
      auth: true,
      title: "Detalhes do Chamado",
      icon: "email",
      toolbarColor: "primary",
    },
  },

  {
    path: "sales",
    name: "sales",
    component: Sales,
    meta: {
      auth: true,
      title: "Sales",
      icon: "sales",
      toolbarColor: 0,
    },
  },
  {
    path: "sale/:id",
    name: "sale",
    component: Sale,
    meta: {
      auth: true,
      title: "Detalhes da Contratação",
      icon: "sale",
      toolbarColor: 0,
    },
  },
  {
    path: "finances",
    name: "finances",
    component: Finances,
    meta: {
      auth: true,
      title: "Finances",
      icon: "finances",
      toolbarColor: 0,
    },
  },
  {
    path: "persons",
    name: "persons",
    component: Persons,
    meta: {
      auth: true,
      title: "Persons",
      icon: "persons",
      toolbarColor: 0,
    },
  },
  {
    path: "orders",
    name: "orders",
    component: Orders,
    meta: {
      auth: true,
      title: "Ordens de Serviço",
      icon: "build",
      toolbarColor: "primary",
    },
  },
  {
    path: "order/:id",
    name: "order",
    component: Order,
    meta: {
      auth: true,
      title: "Detalhes da Ordem de Serviço",
      icon: "build",
      toolbarColor: "primary",
    },
  },
  {
    path: "wells",
    name: "wells",
    component: Wells,
    meta: {
      auth: true,
      title: "Lista de Poços",
      icon: "water_drop",
      toolbarColor: "primary",
    },
  },
  {
    path: "well/:id",
    name: "well",
    component: Well,
    meta: {
      auth: true,
      title: "Detalhes do Poço",
      icon: "water_drop",
      toolbarColor: "primary",
    },
  },
  {
    path: "graduation-report",
    name: "graduation-report",
    component: GraduationReport,
    meta: {
      auth: true,
      title: "graduation-report",
      icon: "graduationReport",
      toolbarColor: 0,
    },
  },
];
